/**
 * Types de partenaires — miroir backend/constants/carePartnerTypes.js
 */

export const CARE_PARTNER_TYPES = {
  HOSPITAL: { id: 'HOSPITAL', label: 'Hôpital / établissement hospitalier' },
  OPHTHALMOLOGY: { id: 'OPHTHALMOLOGY', label: 'Ophtalmologie' },
  PEDIATRICS: { id: 'PEDIATRICS', label: 'Pédiatrie' },
  OPTICAL: { id: 'OPTICAL', label: 'Optique / lunetterie' },
  OTHER: { id: 'OTHER', label: 'Autre partenaire' }
};

export const CATEGORY_TO_PARTNER_TYPE = {
  HOSPITAL_REFERRAL: CARE_PARTNER_TYPES.HOSPITAL.id,
  OPHTHALMOLOGY: CARE_PARTNER_TYPES.OPHTHALMOLOGY.id,
  PEDIATRICS: CARE_PARTNER_TYPES.PEDIATRICS.id,
  OPTICAL: CARE_PARTNER_TYPES.OPTICAL.id
};

export function partnerTypeForCategory(categoryId) {
  return CATEGORY_TO_PARTNER_TYPE[String(categoryId || '').toUpperCase()] || null;
}
